import React from "react";
import PropTypes from "prop-types";

/**
 * FedRamp Provider Details Modal Content
 * @param {Object} props
 * @param {FedRampProviderViewModel} props.providerDetails
 */
export default function ProviderDetailsContent({ providerDetails }) {
  function showAffiliateText() {
    return providerDetails.providerSeq > 0 && providerDetails.compressedProviderName !==
           providerDetails.compressedDefaultProviderName;
  }

  return (<>
    <span>
      {showAffiliateText() && <p className="fedramp-hasAcquired">
        <strong>{providerDetails.providerName}</strong> is an affiliate/subsidiary of the SEWP
        Provider <strong>{providerDetails.providerDefaultName}</strong>
      </p>}
      <p>
        <a className="fedramp-providerAnchor" href={providerDetails.providerUrl}
           target="_blank">{providerDetails.providerDefaultName}</a></p>
    </span>
    <span>
      <div className="fedramp-modalPopUpheading">Description</div>
      {providerDetails.providerDescription}
    </span>
    <span>
      <div className="fedramp-modalPopUpheading">Address</div>
      <div className="fedramp-addressDiv">
        {providerDetails.address0}
        {providerDetails.address1 && <>{", "}{providerDetails.address1}</>}
        {providerDetails.address2 && <>{", "}{providerDetails.address2}</>}
        {providerDetails.address3 && <>{", "}{providerDetails.address3}</>}
        <br/>
        {providerDetails.city}
        {providerDetails.state && <>{", "}{providerDetails.state}</>}
        {providerDetails.zip && <>{" "}{providerDetails.zip}</>}
        {providerDetails.country && <><br/>{providerDetails.country}</>}
      </div>
    </span>
    <span>
      <div className="fedramp-modalPopUpheading">Affiliates/Subsidiaries</div>
      {providerDetails.providerAliases.length === 0 ?
        <p className="fedramp-nothingFound">No Affiliates/Subsidiaries to display</p> :
        <ol>
          {providerDetails.providerAliases.map(({ aliasName, compressedAliasName }) => {
            if (providerDetails.compressedProviderName.toUpperCase() === compressedAliasName.toUpperCase() &&
                providerDetails.compressedProviderName !== providerDetails.compressedDefaultProviderName) {
              return <strong key={aliasName + compressedAliasName}>
                <li style={{ color: "#F1B21C" }}>&nbsp;{aliasName}</li>
              </strong>;
            } else {
              return <li key={aliasName + compressedAliasName}>
                &nbsp;{aliasName}
              </li>;
            }
          })}
        </ol>}
    </span>
  </>);
}

ProviderDetailsContent.propTypes = {
  providerDetails: PropTypes.object.isRequired,
};